import { ParamConfig } from "../../engine/nodes/utils/params/ParamsConfig";
import { ColorConversion } from "../Color";
import { Vector3 } from "three";
import { Color } from "three";
export const DEFAULT_POINT_LIGHT_PARAMS = {
  skyColor: new Color(1, 1, 1),
  groundColor: new Color(0, 0, 0),
  intensity: 1,
  position: new Vector3(0, 0, 0)
};
const DEFAULT = DEFAULT_POINT_LIGHT_PARAMS;
export function HemisphereLightParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.skyColor = ParamConfig.COLOR(DEFAULT.skyColor.toArray(), {
        conversion: ColorConversion.SRGB_TO_LINEAR
      });
      this.groundColor = ParamConfig.COLOR(DEFAULT.groundColor.toArray(), {
        conversion: ColorConversion.SRGB_TO_LINEAR
      });
      this.intensity = ParamConfig.FLOAT(DEFAULT.intensity, {
        range: [0, 10],
        rangeLocked: [true, false]
      });
      this.position = ParamConfig.VECTOR3(DEFAULT.position.toArray());
    }
  };
}
